import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=6e3c5474&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=tsx&"
export * from "./Profile.vue?vue&type=script&lang=tsx&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=6e3c5474&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c5474",
  null
  
)

export default component.exports